export class TransferRecordIdentityKeyValue {
	public ColumnName: string;
	public ColumnValue: string;

	public constructor(params: Required<TransferRecordIdentityKeyValue>) {
		this.ColumnName = params.ColumnName;
		this.ColumnValue = params.ColumnValue;
	}
}
